import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  accessToken: string | null

  setUser: (user: User | null) => void
  setAccessToken: (token: string | null) => void
  setAuth: (user: User, token: string) => void
  logout: () => void
  isAuthenticated: () => boolean
  isPractitioner: () => boolean
  isClient: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,

      setUser: (user) => set({ user }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setAuth: (user, accessToken) => set({ user, accessToken }),

      logout: () => set({ user: null, accessToken: null }),

      isAuthenticated: () => get().user !== null,
      isPractitioner: () => get().user?.role === 'PRACTITIONER',
      isClient: () => get().user?.role === 'CLIENT',
    }),
    {
      name: 'lumina-auth',
      // Only persist user info — access token lives in memory only.
      // Refresh token is in an httpOnly cookie managed by the server.
      partialize: (state) => ({ user: state.user }),
    },
  ),
)
